import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { checkAuthentication } from "./api/axios";
export const AuthContext = createContext({
    isAuthenticated: false,
    setIsAuthenticated: () => { },
    loading: false,
    setLoading: () => { },
    retry: false,
    setRetry: () => { },
    resetContext: () => { },
});
export const AuthContextProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [retry, setRetry] = useState(true);
    const resetContext = () => {
        setIsAuthenticated(false);
        setLoading(true);
        setRetry(true);
    };
    useEffect(() => {
        checkAuthentication({
            isAuthenticated,
            setIsAuthenticated,
            loading,
            setLoading,
            retry,
            setRetry,
            resetContext,
        });
    }, []);
    return (_jsx(AuthContext.Provider, Object.assign({ value: {
            isAuthenticated,
            setIsAuthenticated,
            loading,
            setLoading,
            retry,
            setRetry,
            resetContext,
        } }, { children: children })));
};
export const useAuth = () => useContext(AuthContext);
